export const colors = {
  background: "#121212",
  border: "#363636",
  muted: "#ABABAB",
  surface: "#242424",
  text: "#FAFAFA",
  green: "#00FF3C",
};
